import { render, staticRenderFns } from "./RemoteIcon.vue?vue&type=template&id=f9f457fc&scoped=true&"
import script from "./RemoteIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RemoteIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f457fc",
  null
  
)

export default component.exports